<template>
    <div>
        <q-avatar 
            :rounded="!cropping"
            :square="cropping"
            :size="cropping ? '350px' : '200px'"
            :style="`overflow:hidden;background-color: ${(cropping || user.avatar_path) ? 'transparent' : '#009688'};transition: all 0.15s ease-in-out;`"
            class="relative-position text-white"
            @mouseover="hovering = true"
            @mouseleave="hovering = false"
        >
            <template v-if="cropping">
                <cropper
                    :src="form.url"
                    :stencil-props="{
                        aspectRatio: 1/1
                    }"
                    style="width: 100%;height: 100%;"
                    @change="onCropChange"
                />
            </template>
            <template v-else>
                <template v-if="!user.avatar_path || avatarBroken">
                    {{ user.name.charAt(0) }}
                </template>
                <img v-else @error="avatarBroken = true" :src="user.avatar_path">
            </template>

            <template v-if="!cropping || loading">
                <q-inner-loading :style="`background-color: rgba(0,0,0, 50%);`" :showing="hovering || (loading && !hovering)">
                    <q-spinner v-if="loading" color="primary" size="2rem" />
                    <template v-else>
                        <q-btn
                            @click.prevent="$refs.avatarInput.click()"
                            flat
                            round
                            dense
                            icon="mdi-pencil"
                        >
                            <q-tooltip>Change avatar</q-tooltip>
                        </q-btn>
                        <input
                            ref="avatarInput"
                            type="file"
                            accept="image/png, image/jpeg"
                            style="display: none;"
                            @change="onChange"
                        />
                    </template>
                </q-inner-loading>
            </template>
        </q-avatar>
        <div 
            v-if="cropping"
            class="q-mx-auto bg-grey-10 q-pa-sm"
            :style="'width: ' + (cropping ? '350px' : '200px')"
        >
            <q-linear-progress
                size="xs"
                color="accent"
                v-if="loading && uploading"
                :value="progress"
            />
            <q-btn
                @click="reset()"
                flat
                round
                dense
                color="negative"
                icon="mdi-close"
                :disable="uploading || loading"
            >
                <q-tooltip>Cancel</q-tooltip>
            </q-btn>
            <q-btn
                @click="submit"
                flat
                round
                dense
                color="positive"
                icon="mdi-check"
                :disable="uploading || loading"
            >
                <q-tooltip>Save</q-tooltip>
            </q-btn>
        </div>
    </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
    name: 'ProfileDialogAvatar',
    components: {
        Cropper,
    },
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            loading: false,
            uploading: false,
            hovering: false,
            cropping: false,
            form: {
                url: this.user.avatar,
                file: null,
                height: 0,
                width: 0,
                x: 0,
                y: 0,
            },
            progress: 0,
            avatarBroken: false,
        };
    },
    methods: {
        onCropChange(e) {
            this.form.width = e.coordinates.width;
            this.form.height = e.coordinates.height;
            this.form.x = e.coordinates.left;
            this.form.y = e.coordinates.top;
        },
        onChange(e) {
            const files = e.target.files || e.dataTransfer.files;
            
            if (!files.length) return;

            // console.log(files[0]);

            this.form.file = files[0];

            this.createImage(files[0]);

            this.cropping = true;
        },
        createImage(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.form.url = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        reset() {
            this.cropping = false;
            this.form = {
                url: this.user.avatar,
                file: null,
                height: 0,
                width: 0,
                x: 0,
                y: 0,
            };
        },
        submit() {
            this.loading = true;
            this.uploading = true;

            const formData = new FormData();
            formData.append('avatar', this.form.file, this.form.file.name);
            formData.append('height', this.form.height);
            formData.append('width', this.form.width);
            formData.append('left', this.form.x);
            formData.append('top', this.form.y);

            this.axios.post('/user/avatar', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    this.progress =
                        Math.round(
                            (progressEvent.loaded / progressEvent.total) *
                                100,
                        ) / 100;
                },
            }).then(({data}) => {
                if (data.success) {
                    this.$emit('update');
                    
                    this.reset();
                }

                // console.log(data);
                this.loading = false;
                this.uploading = false;
            }).catch((error) => {
                this.loading = false;
                this.uploading = false;
            });
        }
    },
    // mounted() {
    //     // console.log(this.route().t.url);
    // }
}
</script>